import React from 'react';
import './loader.css';

export const Loader = () => {
    return (
        <div className='loader'>
            <div className='text-primary d-flex flex-column justify-content-center align-content-center h-100' role='status'>
                <img src="/assets/images/logo.svg" alt="Cargando..."/>
                <h6 className="text-center">Cargando...</h6>
            </div>
        </div>
    )
}
